import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function NovoProcesso() {
  const navigate = useNavigate();

  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  const [form, setForm] = useState({
    cliente_id: "",
    numero: "",
    vara: "",
    status: "ativo"
  });

  useEffect(() => {
    api.get("/clientes_list.php")
      .then(res => setClientes(res.data))
      .catch(() => alert("Erro ao carregar clientes"))
      .finally(() => setLoading(false));
  }, []);

fetch("https://ngs.adv.br/api/clientes_list.php", {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token")
  }
})
.then(r => r.json())
.then(console.log)


  function handleChange(field, value) {
    setForm(prev => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!form.cliente_id || !form.numero || !form.vara) {
      alert("Preencha todos os campos obrigatórios");
      return;
    }

    setSalvando(true);

    try {
      await api.post("/processo_create.php", form);
      alert("Processo criado com sucesso");
      navigate("/app/processos");
    } catch (err) {
      console.error(err);
      alert("Erro ao salvar processo");
    } finally {
      setSalvando(false);
    }
  }

  if (loading) {
    return (
      <AppLayout title="Novo Processo">
        <p className="text-slate-400">Carregando clientes…</p>
      </AppLayout>
    );
  }

  return (
    <AppLayout
      title="Novo Processo"
      subtitle="Cadastro de novo processo jurídico"
    >
      <form
        onSubmit={handleSubmit}
        className="max-w-xl space-y-4"
      >

        {/* CLIENTE */}
        <select
          required
          value={form.cliente_id}
          onChange={e => handleChange("cliente_id", e.target.value)}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        >
          <option value="">Selecione o cliente</option>
          {clientes.map(c => (
            <option key={c.id} value={c.id}>
              {c.nome}
            </option>
          ))}
        </select>

        {/* NÚMERO */}
        <input
          required
          placeholder="Número do processo"
          value={form.numero}
          onChange={e => handleChange("numero", e.target.value)}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        />

        {/* VARA */}
        <input
          required
          placeholder="Vara / Tribunal"
          value={form.vara}
          onChange={e => handleChange("vara", e.target.value)}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        />

        {/* STATUS */}
        <select
          value={form.status}
          onChange={e => handleChange("status", e.target.value)}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        >
          <option value="ativo">Ativo</option>
          <option value="suspenso">Suspenso</option>
          <option value="arquivado">Arquivado</option>
        </select>

        {/* BOTÃO */}
        <button
          disabled={salvando}
          className="
            rounded-xl bg-blue-600 px-5 py-3 font-semibold
            hover:bg-blue-500 transition disabled:opacity-60
          "
        >
          {salvando ? "Salvando…" : "Salvar processo"}
        </button>
      </form>
    </AppLayout>
  );
}
